import React from 'react';

import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import MailOutlineIcon from '@material-ui/icons/MailOutline';

type Props = {
  onClick: () => void;
  disabled?: boolean;
  isLogin: boolean;
};

const useStyles = makeStyles((theme) => ({
  logo: {
    width: 20,
    height: 20,
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(),
  },
  grow: {
    width: 10,
  },
}));

export default function EmailButton({ onClick, disabled, isLogin }: Props) {
  const classes = useStyles();

  return (
    <Button
      variant="contained"
      size="large"
      fullWidth
      onClick={onClick}
      disabled={disabled}
      className={classes.container}
      startIcon={<MailOutlineIcon className={classes.logo} />}
    >
      {isLogin ? 'Log In with Email' : 'Sign Up with Email'}
      <div className={classes.grow} />
    </Button>
  );
}
